// extracted by mini-css-extract-plugin
export default {"magazine":"magazine_magazine__mXlzx","wrapper":"magazine_wrapper__DXGev","magazineCard":"magazine_magazineCard__sCX6f"};